import React, { useContext } from 'react';
import { RadioButton, CaptionText, DropdownMenu } from '@paypalcorp/pp-react';
import styles from '../Configurator.module.less';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import { trackFieldChange, trackFieldFocus, trackFieldClosed } from '../../../lib/fpti';

const ButtonConfigurator = () => {
  const {
    ButtonConfigurator: {
      colorOptions,
      labelOptions,
      buttonSettings,
      layoutOptions,
      shapeOptions,
      updateButtonSettings
    },
    SdkConfigurator: { sdkSettings: { buyerCountry } = /* istanbul ignore next line */ {} },
    code: { updateActiveCodeBlock, status }
  } = useContext(IntegrationPageSectionContext);

  return (
    <div className={styles.configuration}>
      <div className={styles.configuration_item}>
        <CaptionText className={styles.configuration_text}>Button Shape</CaptionText>
        <RadioButton
          name="buttonShape"
          className={styles.configuration_radio}
          value={buttonSettings.shape}
          onChange={(e) => {
            trackFieldChange('Button Shape', e.target.value);
            updateButtonSettings(e.target.value, 'shape');
          }}
          options={shapeOptions}
        />
      </div>
      <div className={styles.configuration_item}>
        <CaptionText className={styles.configuration_text}>Button Color</CaptionText>
        <DropdownMenu
          label="Button Color"
          className={styles.configuration_dropdown}
          options={colorOptions.default}
          value={buttonSettings.color}
          onClick={() => trackFieldFocus('Button Color')}
          onChange={(e) => {
            trackFieldChange('Button Color', e.target.value);
            updateButtonSettings(e.target.value, 'color');
          }}
          onClose={() => trackFieldClosed('Button Color')}
        />
      </div>
      <div className={styles.configuration_item}>
        <CaptionText className={styles.configuration_text}>Button Layout</CaptionText>
        <div className={styles.configuration_field_wrapper}>
          <RadioButton
            name="buttonLayout"
            className={styles.configuration_radio}
            value={buttonSettings.layout}
            onChange={(e) => {
              trackFieldChange('Button Layout', e.target.value);
              updateButtonSettings(e.target.value, 'layout');
            }}
            options={layoutOptions}
          />
        </div>
      </div>
      <div className={styles.configuration_item}>
        <CaptionText className={styles.configuration_text}>Button Label Text</CaptionText>
        <DropdownMenu
          label="Button Label"
          className={styles.configuration_dropdown}
          options={labelOptions}
          value={buttonSettings.label}
          onClick={() => trackFieldFocus('Button Label')}
          onChange={(e) => {
            trackFieldChange('Button Label', e.target.value);
            updateButtonSettings(e.target.value, 'label');
          }}
          onClose={() => trackFieldClosed('Button Label')}
        />
      </div>
      {buyerCountry === 'US' && (
        <div className={styles.configuration_item}>
          <CaptionText className={styles.configuration_text}>Button Message</CaptionText>
          <RadioButton
            label="Button Message"
            className={styles.configuration_radio}
            options={[
              {
                label: 'Enable',
                value: true
              },
              {
                label: 'Disable',
                value: false
              }
            ]}
            value={status.configureButtonMessages}
            onChange={(e) => {
              trackFieldChange('Button Message', e.target.value);
              updateActiveCodeBlock({
                value: e.target.value === 'true',
                key: 'configureButtonMessages'
              });
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ButtonConfigurator;
